import TeamImg1 from "../../assets/img/team/Team1.webp";
import TeamImg2 from "../../assets/img/team/Team2.webp";
import TeamImg3 from "../../assets/img/team/Team3.webp";
import TeamImg4 from "../../assets/img/team/Team4.webp";
import CarouselHero from "../../assets/img/hero/hero.webp";
import CarouselHero2 from "../../assets/img/hero/heroimg.webp";
import CarouselHero3 from "../../assets/img/hero/heroimg2.webp";
import CarouselHero4 from "../../assets/img/hero/heroimg3.webp";
import CarouselHero5 from "../../assets/img/hero/heroimg4.webp";
import CardImg1 from "../../assets/img/cards/cardimg1.webp";
import CardImg2 from "../../assets/img/cards/cardimg2.webp";
import CardImg3 from "../../assets/img/cards/cardimg3.webp";
import CardImg4 from "../../assets/img/cards/cardimg4.webp";
import ManImg from "../../assets/img/feedback/man.webp";
import StarImg from "../../assets/img/feedback/star.webp";
import TeamCardImg1 from "../../assets/img/teamcards/teamcard1.png";
import TeamCardImg2 from "../../assets/img/teamcards/teamcard2.png";
export const TeamData = [
  {
    img: TeamImg1,
    heading: "Maria Korsgaard ",
    text: "Finicial Advisor",
  },
  {
    img: TeamImg2,
    heading: "Jaydon Bator",
    text: "CEO",
  },
  {
    img: TeamImg3,
    heading: "Leo Workman",
    text: "Co-Founder",
  },
  {
    img: TeamImg4,
    heading: "Lincoln Philips",
    text: "Invester",
  },
];
export const HeroData = [
  {
    img: CarouselHero,
    heading: "Welcome To l2 Global Technologies",
    text: "Urna, sem amet neque ac. In tellus morbi facilisi est tortor ultrices. Suspendisse eget consequat mi pulvinar. ",
  },
  {
    img: CarouselHero2,
    heading: "Let your mind  Explore new worlds",
    text: "It gives you the freedom to do it all, Games,entertainment,live events, fitness and more. ",
  },
  {
    img: CarouselHero3,
    heading: "Nulla ipsum bibendum leo urna.",
    text: "Pellentesque at massa, elit suscipit etiam neque volutpat quis pellentesque. Sagittis, viverra enim est quis. ",
  },
  {
    img: CarouselHero4,
    heading: "Nulla ipsum bibendum leo urna. Id.",
    text: "Pellentesque at massa, elit suscipit etiam neque volutpat quis pellentesque. Sagittis, viverra enim est quis. ",
  },
  {
    img: CarouselHero5,
    heading: "Nulla ipsum bibendum leo urna. Id.",
    text: "Pellentesque at massa, elit suscipit etiam neque volutpat quis pellentesque. Sagittis, viverra enim est quis. ",
  },
];

export const CardsImgData = [
  {
    img: CardImg1,
    heading: "VISION",
    text: "Convallis suscipit quam justo, pulvinar lobortis. ",
  },
  {
    img: CardImg2,
    heading: "STRATEGY",
    text: "Convallis suscipit quam justo, pulvinar lobortis.  ",
  },
  {
    img: CardImg3,
    heading: "VALUES",
    text: "Convallis suscipit quam justo, pulvinar lobortis.  ",
  },
  {
    img: CardImg4,
    heading: "MISSION",
    text: "Convallis suscipit quam justo, pulvinar lobortis. ",
  },
  {
    img: CardImg1,
    heading: "VISION",
    text: "Convallis suscipit quam justo, pulvinar lobortis. ",
  },
  {
    img: CardImg2,
    heading: "STRATEGY",
    text: "Convallis suscipit quam justo, pulvinar lobortis.  ",
  },
];
export const FeedbackSliderData = [
  {
    heading: "Customers And Feedback",
    img: ManImg,
    starimg: StarImg,
    para: "Pellentesque lacus, ut lorem eu quis maecenas nibh. Donec netus sit tortor, ac. Non magna ut convallis aliquam cursus. Maecenas viverra in sed elit m",
    smallHeading: "Cordkf Advsww",
    text: "FINICIAL ANALYST",
  },
  {
    heading: "Customers And Feedback",
    img: ManImg,
    starimg: StarImg,
    para: "Pellentesque lacus, ut lorem eu quis maecenas nibh. Donec netus sit tortor, ac. Non magna ut convallis aliquam cursus. Maecenas viverra in sed elit m",
    smallHeading: "Cordkf Advsww",
    text: "FINICIAL ANALYST",
  },
  {
    heading: "Customers And Feedback",
    img: ManImg,
    starimg: StarImg,
    para: "Pellentesque lacus, ut lorem eu quis maecenas nibh. Donec netus sit tortor, ac. Non magna ut convallis aliquam cursus. Maecenas viverra in sed elit m",
    smallHeading: "Cordkf Advsww",
    text: "FINICIAL ANALYST",
  },
  {
    heading: "Customers And Feedback",
    img: ManImg,
    starimg: StarImg,
    para: "Pellentesque lacus, ut lorem eu quis maecenas nibh. Donec netus sit tortor, ac. Non magna ut convallis aliquam cursus. Maecenas viverra in sed elit m",
    smallHeading: "Cordkf Advsww",
    text: "FINICIAL ANALYST",
  },
];
export const TeamCardsData = [
  {
    img: TeamCardImg1,
    heading: "Maria Korsgaard",
    text: "Finicial Advisor",
  },
  {
    img: TeamCardImg2,
    heading: "Maria Korsgaard",
    text: "Finicial Advisor",
  },
  {
    img: TeamCardImg2,
    heading: "Lincoln Philips",
    text: "Invester",
  },
];
